{
  "name": "hec",
  "version": "3.0.11",
  "author": "Jason and Cath Hopkins",
  "homepage": "https://www.hec.co.uk/",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "ionic:build": "ng build",
    "ionic:build:staging": "ng build --configuration=staging",
    "cap:sync:staging:ios": "npm run ionic:build:staging && npx cap sync ios",
    "cap:sync:staging:android": "npm run ionic:build:staging && npx cap sync android",
    "cap:sync:prod:ios": "npm run ionic:build && npx cap sync ios",
    "cap:sync:prod:android": "npm run ionic:build && npx cap sync android",
    "cleanup:sourcemaps": "find ./www -name '*.js.map' -delete",
    "build-release": "node build-release.js",
    "watch": "ng build --watch --configuration development",
    "web": "ng build --watch --configuration web",
    "test": "ng test",
    "lint": "ng lint && npm run lint:styles",
    "lint:styles": "node scripts/check-colour-literals.mjs",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org hec-4z --project javascript-angular --release hec@$npm_package_version ./www && sentry-cli sourcemaps upload --org hec-4z --project javascript-angular --release hec@$npm_package_version ./www",
    "distribute:ios": "/usr/local/opt/ruby/bin/bundle exec fastlane ios release",
    "distribute:android": "/usr/local/opt/ruby/bin/bundle exec fastlane android release"
  },
  "private": true,
  "dependencies": {
    "@aashu-dubey/capacitor-statusbar-safe-area": "^4.0.0",
    "@angular/common": "20.3.18",
    "@angular/core": "20.3.18",
    "@angular/forms": "20.3.18",
    "@angular/platform-browser": "20.3.18",
    "@angular/platform-browser-dynamic": "20.3.18",
    "@angular/platform-server": "20.3.18",
    "@angular/router": "20.3.18",
    "@capacitor-community/in-app-review": "8.0.0",
    "@capacitor/android": "^8.0.0",
    "@capacitor/app": "^8.0.0",
    "@capacitor/browser": "^8.0.0",
    "@capacitor/camera": "^8.0.0",
    "@capacitor/core": "^8.0.0",
    "@capacitor/device": "8.0.2",
    "@capacitor/filesystem": "^8.0.0",
    "@capacitor/haptics": "^8.0.0",
    "@capacitor/ios": "^8.0.0",
    "@capacitor/keyboard": "^8.0.0",
    "@capacitor/local-notifications": "^8.0.1",
    "@capacitor/network": "^8.0.0",
    "@capacitor/preferences": "^8.0.0",
    "@capacitor/share": "^8.0.0",
    "@capacitor/splash-screen": "^8.0.0",
    "@capacitor/status-bar": "^8.0.0",
    "@ionic/angular": "^8.6.1",
    "@ionic/angular-server": "^8.6.0",
    "@ionic/pwa-elements": "^3.3.0",
    "@ionic/storage": "^4.0.0",
    "@revenuecat/purchases-capacitor": "^13.4.0",
    "@revenuecat/purchases-js": "^1.26.0",
    "@revenuecat/purchases-ui-js": "^1.0.2",
    "@sentry/angular": "^9.42.0",
    "@sentry/cli": "^2.52.0",
    "@types/uuid": "^10.0.0",
    "angular-oauth2-oidc": "^20.0.0",
    "chart.js": "^4.4.9",
    "cordova-sqlite-storage": "^7.0.0",
    "date-fns": "^4.1.0",
    "ionicons": "^8.0.9",
    "localforage-cordovasqlitedriver": "^1.8.0",
    "noode": "^0.0.63",
    "posthog-js": "1.435.8",
    "rxjs": "~7.8.2",
    "swiper": "12.1.3",
    "tinyduration": "^3.4.1",
    "tslib": "^2.8.1",
    "util": "^0.12.5",
    "uuidv7": "^1.0.2",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "~20.3.15",
    "@angular-eslint/builder": "~20.7.0",
    "@angular-eslint/eslint-plugin": "~20.7.0",
    "@angular-eslint/eslint-plugin-template": "~20.7.0",
    "@angular-eslint/schematics": "~20.7.0",
    "@angular-eslint/template-parser": "~20.7.0",
    "@angular/cli": "~20.3.15",
    "@angular/compiler": "20.3.18",
    "@angular/compiler-cli": "20.3.18",
    "@angular/language-service": "~20.3.16",
    "@capacitor/cli": "^8.0.0",
    "@ionic/angular-toolkit": "^12.2.0",
    "@lavamoat/allow-scripts": "^4.0.0",
    "@lavamoat/preinstall-always-fail": "^3.0.0",
    "@types/jasmine": "~5.1.8",
    "@types/node": "^24.0.0",
    "@typescript-eslint/eslint-plugin": "^8.34.0",
    "@typescript-eslint/parser": "^8.34.0",
    "eslint": "^9.28.0",
    "eslint-plugin-import": "2.31.0",
    "eslint-plugin-jsdoc": "50.7.1",
    "eslint-plugin-prefer-arrow": "1.2.3",
    "jasmine-core": "~5.8.0",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-coverage-istanbul-reporter": "~3.0.3",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "ts-node": "~10.9.2",
    "typescript": "~5.8.3"
  },
  "description": "A HEC production",
  "lavamoat": {
    "allowScripts": {
      "@angular-devkit/build-angular>@angular/build>lmdb": false,
      "@angular-devkit/build-angular>@angular/build>lmdb>msgpackr>msgpackr-extract": false,
      "@angular-devkit/build-angular>esbuild": false,
      "@angular-devkit/build-angular>sass>@parcel/watcher": false,
      "@lavamoat/preinstall-always-fail": false,
      "@sentry/cli": false,
      "posthog-js>core-js": false,
      "@parcel/watcher": true,
      "lmdb": true,
      "msgpackr-extract": true
    }
  }
}
